// extracted by mini-css-extract-plugin
module.exports = {"settingIcon":"add-property_settingIcon__uUe31","addProperty":"add-property_addProperty__2HrAX"};